// Don't redirect to login page for these routes:
const allowedNonAuthRoutes = ['forgot-password', 'signup'];

// Is a redirect to login required for the current route (if no valid logged-in user found)
export const routeRequiresLogin = () => {
  const firstRouteSection = window.location.pathname.split('/')[1];
  return !allowedNonAuthRoutes.includes(firstRouteSection);
};
